import _ from "lodash";
import {
  checkStatus,
  parseJSON,
  getApiUrl,
  getPhpApiUrl,
} from "./ServiceHelper";
import { getLoggedInUser } from "./AuthenticationService";
import { getAccessToken } from "./AuthenticationService";
import { base64UrlEncode } from "../lib/helper";

// function getApiUrl() {
//   return "https://api-php-dev.12u12.com/api/";
// }
function getHeaderForAjax() {
  return new Headers({
    "Content-Type": "application/json",
    token: getAccessToken(),
    user: getLoggedInUser()._id,
  });
}
function normalizeDraft(draft) {
  // Backend contract:
  // - 0 => non-draft only
  // - 1 => draft only
  // - "" => both draft and non-draft
  if (draft === "") return "";
  if (draft === 1 || draft === "1" || draft === true) return 1;
  if (draft === 0 || draft === "0" || draft === false) return 0;
  // Any unexpected values (undefined, null, objects, arrays) → default to 0
  return 0;
}
export function langList() {
  let url = `${getPhpApiUrl()}/forum/langList`;
  let method = "GET";
  return fetch(url, {
    method: method,
    headers: getHeaderForAjax(),
  })
    .then(checkStatus)
    .then(parseJSON);
}
export function shareForum(inputs, linksToNewPostItems, draft = false) {
  let lang = getLoggedInUser().lang;
  let body = {
    body: inputs.body,
    symptom: inputs.symptom,
    draft: draft ? draft : false,
    lang: lang, // || "1200000000001000022", // default to English
  };
  if (linksToNewPostItems) {
    body.related = linksToNewPostItems;
  }
  let url = getPhpApiUrl() + "/forum/share";
  let method = "POST";
  return fetch(url, {
    method: method,
    headers: getHeaderForAjax(),
    body: JSON.stringify(body),
  })
    .then(checkStatus)
    .then(parseJSON);
}
export function doArchiveService(data) {
  let body = {
    post: data,
  };
  let url = getPhpApiUrl() + "/forum/savepost";
  let method = "POST";
  return fetch(url, {
    method: method,
    headers: getHeaderForAjax(),
    body: JSON.stringify(body),
  })
    .then(checkStatus)
    .then(parseJSON);
}
export function editForum(inputs, isdraft) {
  let user = getLoggedInUser()._id;
  let edited = 1;
  let draft = false;
  if (isdraft == true) {
    draft = true;
  }
  let body = {
    body: inputs.body,
    edited: edited,
    draft: draft,
  };
  let url = getPhpApiUrl() + "/forum/edit/" + inputs._id;
  let method = "PUT";

  // Trigger Linked Post Republished notification only when user clicks Publish button
  if (isdraft === false) {
    fetch(`${getApiUrl()}/users/${user}/forum/${inputs._id}/republish`, {
      method: method,
      headers: new Headers({
        "Content-Type": "application/json",
        token: getAccessToken(),
      }),
    }).catch(() => {}); // don't block edit on a failed notify
  }

  return fetch(url, {
    method: method,
    headers: getHeaderForAjax(),
    body: JSON.stringify(body),
  })
    .then(checkStatus)
    .then(parseJSON);
}
// export function getList(symptomId, sortBy, keyWord, userId, draft, lang) {
//   symptomId = symptomId == "null" ? "" : symptomId;
//   sortBy = sortBy || "";
//   keyWord = keyWord || "";
//   // const draftParam = normalizeDraft(draft);
//   draft = normalizeDraft(draft);
//   userId = userId || "";
//   lang = lang && lang != "null" ? lang : "";

//   let url = `${getPhpApiUrl()}/forum/index?symptom=${symptomId}&sortby=${sortBy}&keyword=${keyWord}&user_id=${userId}&draft=${draft}&lang=${lang}`;

//   let method = "GET";
//   return fetch(url, {
//     method: method,
//     headers: getHeaderForAjax(),
//   })
//     .then(checkStatus)
//     .then(parseJSON);
// }

export function getList(symptomId, sortBy, keyWord, userId, draft, lang) {
  symptomId = symptomId == "null" ? "" : symptomId;
  sortBy = sortBy || "";
  keyWord = keyWord || "";      // DO NOT trim
  draft = normalizeDraft(draft);
  userId = userId || "";
  lang = lang && lang != "null" ? lang : "";

  const keywordB64 = base64UrlEncode(keyWord);

  let url =
    `${getPhpApiUrl()}/forum/index` +
    `?symptom=${encodeURIComponent(symptomId)}` +
    `&sortby=${encodeURIComponent(sortBy)}` +
    `&keyword_b64=${encodeURIComponent(keywordB64)}` +
    `&user_id=${encodeURIComponent(userId)}` +
    `&draft=${encodeURIComponent(draft)}` +
    `&lang=${encodeURIComponent(lang)}`;

  return fetch(url, {
    method: "GET",
    headers: getHeaderForAjax(),
  })
    .then(checkStatus)
    .then(parseJSON);
}


export function getArchiveList() {
  let url = `${getPhpApiUrl()}/forum/listsaved`;
  let method = "GET";
  return fetch(url, {
    method: method,
    headers: getHeaderForAjax(),
  })
    .then(checkStatus)
    .then(parseJSON);
}
export function likedActService(postId, flag) {
  let body = {
    post_id: postId,
  };
  if (flag) {
    body.up = 1;
  } else {
    body.down = 1;
  }
  let url = getPhpApiUrl() + "/forum/relevant";
  let method = "POST";
  return fetch(url, {
    method: method,
    headers: getHeaderForAjax(),
    body: JSON.stringify(body),
  })
    .then(checkStatus)
    .then(parseJSON);
}
export function removeSaveService(postId) {
  let url = getPhpApiUrl() + "/forum/removesaved/" + postId;
  let method = "DELETE";
  return fetch(url, {
    method: method,
    headers: getHeaderForAjax(),
  })
    .then(checkStatus)
    .then(parseJSON);
}
export function deletePostService(postId) {
  let url = getPhpApiUrl() + `/forum/delete/${postId}`;
  let method = "DELETE";
  return fetch(url, {
    method: method,
    headers: getHeaderForAjax(),
  })
    .then(checkStatus)
    .then(parseJSON);
}
export function singlePostGet(postId) {
  let url = `${getPhpApiUrl()}/forum/post/${postId}`;
  let method = "GET";
  return fetch(url, {
    method: method,
    headers: getHeaderForAjax(),
  })
    .then(checkStatus)
    .then(parseJSON);
}
// export function loadMorePost(
//   symptomId,
//   sortBy,
//   keyWord,
//   userId,
//   draft,
//   lang,
//   page
// ) {
//   symptomId = symptomId == "null" ? "" : symptomId;
//   sortBy = sortBy || "";
//   keyWord = keyWord || "";
//   draft = normalizeDraft(draft);
//   // const draftParam = normalizeDraft(draft);
//   userId = userId || "";
//   lang = lang && lang != "null" ? lang : "";

//   let url = `${getPhpApiUrl()}/forum/index?symptom=${symptomId}&sortby=${sortBy}&keyword=${keyWord}&user_id=${userId}&draft=${draft}&lang=${lang}&page=${page}`;

//   let method = "GET";
//   return fetch(url, {
//     method: method,
//     headers: getHeaderForAjax(),
//   })
//     .then(checkStatus)
//     .then(parseJSON);
// }



export function loadMorePost(
  symptomId,
  sortBy,
  keyWord,
  userId,
  draft,
  lang,
  page
) {
  symptomId = symptomId == "null" ? "" : symptomId;
  sortBy = sortBy || "";
  keyWord = keyWord || "";
  draft = normalizeDraft(draft);
  userId = userId || "";
  lang = lang && lang != "null" ? lang : "";

  const keywordB64 = base64UrlEncode(keyWord);

  let url =
    `${getPhpApiUrl()}/forum/index` +
    `?symptom=${encodeURIComponent(symptomId)}` +
    `&sortby=${encodeURIComponent(sortBy)}` +
    `&keyword_b64=${encodeURIComponent(keywordB64)}` +
    `&user_id=${encodeURIComponent(userId)}` +
    `&draft=${encodeURIComponent(draft)}` +
    `&lang=${encodeURIComponent(lang)}` +
    `&page=${encodeURIComponent(page)}`;


  return fetch(url, {
    method: "GET",
    headers: getHeaderForAjax(),
  })
    .then(checkStatus)
    .then(parseJSON);
}



// WEBPACK FOOTER //
// ./src/services/ForumService.js